import axios from 'axios';
import { getAccessToken, refreshToken, clearLogin } from './authService';
import router from '@/router';

const instance = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL, // ou import.meta.env.VITE_API_BASE_URL se usar Vite
  withCredentials: true,
  headers: {
    'x-api-key': process.env.VUE_APP_API_KEY,
  },
});

instance.interceptors.request.use(async (config) => {
  const token = getAccessToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

instance.interceptors.response.use(null, async (error) => {
  const originalRequest = error.config;

  // Ignorar requisições de refresh para evitar loop infinito
  if (originalRequest.url.includes('/admin/login/refresh') || !localStorage.getItem('accessToken')) {
    return Promise.reject(error);
  }

  if (error.response && error.response.status === 401 && !originalRequest._retry) {
    originalRequest._retry = true;

    try {
      await refreshToken();
      return instance(originalRequest);
    } catch (e) {
      const currentPage = window.location.pathname + window.location.search;
      clearLogin();
      sessionStorage.setItem('loginExpired', true);
      // window.location.href = `/login?redirect=${encodeURIComponent(currentPage)}`;
      router.push({ path: '/login', query: { redirect: currentPage } });
      // console.error('Erro ao renovar token', e);
    }
  }

  return Promise.reject(error);
});

instance.isCancel = axios.isCancel;

export default instance;